import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ObjectTypes } from "@common/enums/object-types";
import { GroupValueHelpers, GroupKeyComparatorHelpers, RecordComparatorHelpers, ResultGroup, ResultGroupingDefinition, ResultGroup2, ResultGrouping2Definition } from "@common/data-models/search-results/result-group";
import { SearchResults } from "@common/data-models/search-results/search-results";
import { DataStore } from '@common/data-models/data-store/data-store';
import { Record } from "@common/data-models/records/record";
import { RundownRecord } from "@live/data-models/records/rundown-record";
import { ILiveService } from "@live/interfaces/i-live-service";

export class LiveSearchResults extends SearchResults {

    public static liveService: ILiveService = null;

    public rundowns: Array<RundownRecord> = [];
    public addRundown(rundown: RundownRecord) {
        this.rundowns.push(rundown);
        this.byGuid[rundown.guid] = rundown;
    }

    public getAllResults(): Array<Record> {
        let ret: Array<Record> = [];
        for (let rundown of this.rundowns) {
            ret.push(rundown);
        }
        return ret;
    }

    public rundownGroups: { [id: string]: ResultGroup<RundownRecord> } = {};

    private static _rundownGroupDefs: { [id: string]: ResultGroupingDefinition } = {};
    public static get rundownGroupDefs(): { [id: string]: ResultGroupingDefinition } {
        if ((Object.keys(LiveSearchResults._rundownGroupDefs).length == 0)) {
            LiveSearchResults._rundownGroupDefs[PSTFieldNames.PSTModTime] = new ResultGroupingDefinition(
                GroupValueHelpers.DateTime(PSTFieldNames.PSTModTime),
                GroupKeyComparatorHelpers.Value(),
                RecordComparatorHelpers.DateTime(PSTFieldNames.PSTModTime)
            );

        }
        return LiveSearchResults._rundownGroupDefs;
    }

    private get rundownGroupFields(): Array<string> {
        return LiveSearchResults.liveService.groupByRundownKeys;
    }

    public remove(rec: Record) {
        super.remove(rec);

        if (rec.type == ObjectTypes.RUNDOWN) {
            for (let i = 0; i < this.rundowns.length; i++) {
                if (this.rundowns[i].guid == rec.guid) {
                    this.rundowns.splice(i, 1);
                    break;
                }
            }
            for (let field in LiveSearchResults.rundownGroupDefs) {
                if (this.rundownGroups[field]) this.rundownGroups[field].remove(LiveSearchResults.rundownGroupDefs[field].valueConvertor(rec), <RundownRecord>rec);
            }
        }
    }

    public sortGroups(sortBy: any, sortOrder: string, groupSortOrder: string) {
        if (this.objectType == ObjectTypes.RUNDOWN) {
            let groups = this.getGroups();

            for (let field of groups) {
                this.rundownGroups[field].sort(LiveSearchResults.rundownGroupDefs[field].groupKeyComparator(groupSortOrder), LiveSearchResults.rundownGroupDefs[sortBy].recordComparator(sortOrder));
            }
        }
    }

    public dispose() {
        super.dispose();
        this.objectType = null;
        this.rundowns = [];
        this.users = [];
        this.rundownGroups = {};
    }

    public getGroups(): Array<string> {
        switch (this.objectType) {
            case ObjectTypes.RUNDOWN:
                return this.rundownGroupFields;
            default:
                return ["Type"];
        }
    }

    public rebuildGroups(groupBy: string, sortBy: any, sortOrder: string, groupSortOrder: string) {
        if (this.objectType == ObjectTypes.RUNDOWN) {
            let groups = this.getGroups();
            // Clear all groups
            for (let field of groups) {
                if (!this.rundownGroups[field]) this.rundownGroups[field] = new ResultGroup<RundownRecord>();
                this.rundownGroups[field].clear();
            }
            if (!this.rundownGroups[SearchResults.groupByField]) {
                SearchResults.groupByField = groupBy;
            }
            // Build active group
            for (let rundown of this.rundowns) {
                this.rundownGroups[SearchResults.groupByField].addToGroups(LiveSearchResults.rundownGroupDefs[SearchResults.groupByField].valueConvertor(rundown), rundown);
            }
            this.rundownGroups[SearchResults.groupByField].sort(LiveSearchResults.rundownGroupDefs[SearchResults.groupByField].groupKeyComparator(groupSortOrder), LiveSearchResults.rundownGroupDefs[sortBy].recordComparator(sortOrder));
            this.rundownGroups[SearchResults.groupByField].isBuilt = true;

            // Build the rest of the groups
            for (let field of groups) {
                if (!this.rundownGroups[field]) {
                    return;
                }
                if (this.rundownGroups[field].isBuilt) {
                    continue;
                }
                let i = 0;
                for (let rundown of this.rundowns) {
                    this.rundownGroups[field].addToGroups(LiveSearchResults.rundownGroupDefs[field].valueConvertor(rundown), rundown);
                }
                this.rundownGroups[field].sort(LiveSearchResults.rundownGroupDefs[field].groupKeyComparator(groupSortOrder), LiveSearchResults.rundownGroupDefs[sortBy].recordComparator(sortOrder));
                this.rundownGroups[field].isBuilt = true;
            }
        }
    }
}
DataStore.registerSearchResults("live", new LiveSearchResults());
